//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeOpportunities = (
  opportunities: Serialized<PurchaseOption>[],
): PurchaseOption[] => {
  const deserializedOpportunities = opportunities.map((opportunity) => ({
    ...opportunity,
    created: opportunity.created ? new Date(opportunity.created) : undefined,
    expiryDate: opportunity.expiryDate
      ? new Date(opportunity.expiryDate)
      : undefined,
    updated: opportunity.updated ? new Date(opportunity.updated) : undefined,
  }));

  return deserializedOpportunities;
};
